@let showError = inputFormControl().invalid && isSubmitted();
<div class="d-flex flex-column gap-1">
  <label class="form-input-label" [for]="inputId">{{ label() }}</label>
  <lib-date-input
    [formControl]="inputFormControl()"
    [controlId]="inputId"
    [error]="showError"
    [minDate]="minDate()"
    [maxDate]="maxDate()"
    [useFutureYearOptions]="useFutureYearOptions()">
  </lib-date-input>
  @if (hintText()) {
    <div class="form-input-hint-label" [class.disabled]="inputFormControl().disabled">
      {{ hintText() }}
    </div>
  }
  @if (showError) {
    <lib-form-error [errors]="inputFormControl().errors"></lib-form-error>
  }
</div>
